var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reception-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 11.5C0 11.2239 0.223858 11 0.5 11H2.5C2.77614 11 3 11.2239 3 11.5V13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5V11.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 8.5C4 8.22386 4.22386 8 4.5 8H6.5C6.77614 8 7 8.22386 7 8.5V13.5C7 13.7761 6.77614 14 6.5 14H4.5C4.22386 14 4 13.7761 4 13.5V8.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 5.5C8 5.22386 8.22386 5 8.5 5H10.5C10.7761 5 11 5.22386 11 5.5V13.5C11 13.7761 10.7761 14 10.5 14H8.5C8.22386 14 8 13.7761 8 13.5V5.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 2.5C12 2.22386 12.2239 2 12.5 2H14.5C14.7761 2 15 2.22386 15 2.5V13.5C15 13.7761 14.7761 14 14.5 14H12.5C12.2239 14 12 13.7761 12 13.5V2.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIcon);
export default __webpack_public_path__ + "static/media/networkIcon.73c30f235efcc65e02920d88eec8b490.svg";
export { ForwardRef as ReactComponent };